module.exports = __webpack_public_path__ + "img/KH.705cc2b3.svg";